module.exports = "\r\n <router-outlet name=\"details\"></router-outlet>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/src/app/containers/crestron/crestron-container.component.html
// module id = ../../../../../src/app/containers/crestron/crestron-container.component.html
// module chunks = main